import { BitmapText, Container } from '@pixi/react'
import { formatToCommaWithLang, GodziDropResultType, Image } from '@slot-nx/core'
import { useMemo } from 'react'
import { SpinType } from '../../../domain/betDetail/store/betDetailStore'
import { GameDetailUi } from '../GameDetail/GameDetailUi'
import { GodziDropResult } from '../../../domain/betDetail/models/BetDetailResponse'

interface GodziDetailProps {
  godziDropResult: GodziDropResult // <-- Use the imported interface
  selectSpinType: SpinType
  isFromOpBetDetail: boolean
}

export const GodziDetail = (props: GodziDetailProps) => {
  const { godziDropResult, selectSpinType, isFromOpBetDetail } = props
  const prizeContent = useMemo(() => getPrizeComponent(godziDropResult, selectSpinType, isFromOpBetDetail), [godziDropResult, isFromOpBetDetail, selectSpinType])
  return (
    <Container name="GodziDetail">
      {prizeContent}
    </Container>

  )
}
function getPrizeComponent(godziDropResult: GodziDropResult, selectSpinType: SpinType, isFromOpBetDetail: boolean) { // <-- Use the imported interface
  switch (godziDropResult.type) {
    case GodziDropResultType.None:
      return null
    case GodziDropResultType.RatioPrize:
      return <RatioPrize godziDropResult={godziDropResult} />
    case GodziDropResultType.FreeSpin:
      return <FreeSpinPrize godziDropResult={godziDropResult} />
    case GodziDropResultType.FreeGame:
      return <FreeGamePrize godziDropResult={godziDropResult} selectSpinType={selectSpinType} isFromOpBetDetail={isFromOpBetDetail} />
    default:
      return null
  }
}

export const FreeGamePrize = (props: GodziDetailProps) => {
  const { godziDropResult, selectSpinType, isFromOpBetDetail } = props
  if (godziDropResult.gameResultList === null) return null
  return (
    <Container name="FreeGamePrize">
      <GameDetailUi gameDetail={godziDropResult.gameResultList[0]} selectSpinType={selectSpinType} isFromOpBetDetail={isFromOpBetDetail} />
    </Container>
  )
}

interface FreeSpinPrizeProps {
  godziDropResult: GodziDropResult // <-- Use the imported interface
}

export const FreeSpinPrize = (props: FreeSpinPrizeProps) => {
  const { godziDropResult } = props
  return (
    <Container name="FreeSpinPrize" x={100} y={500}>
      <Image
        name="godziTicket"
        image="image_ticket"
        width={900}
        height={900}
      />
      <Image
        name="godziFreeSpinImage"
        image="image_freeSpin"
        x={225}
        y={200}
        width={464}
        height={176}
      />

      <BitmapText
        text={formatToCommaWithLang(godziDropResult.payout)}
        anchor={[0.5, 2]}
        style={{ fontName: 'GodziFont', fontSize: 30 }}
        x={450}
        y={480}
      />
    </Container>
  )
}
interface RatioPrizeProps {
  godziDropResult: GodziDropResult // <-- Use the imported interface
}

export const RatioPrize = (props: RatioPrizeProps) => {
  const { godziDropResult } = props
  return (
    <Container name="RatioPrize" x={100} y={500}>
      <Image
        name="godziTicket"
        image="image_ticket"
        width={900}
        height={900}
      />
      <Image
        name="godziMultiImage"
        image="image_multiplier"
        x={250}
        y={300}
        width={450}
        height={75}
      />
      <Image
        name="godziXImage"
        image="image_x"
        width={90}
        height={90}
        x={145}
        y={480}
      />
      <BitmapText
        text={godziDropResult.prize.toString()}
        anchor={[0.5, 2]}
        style={{ fontName: 'GodziFont', fontSize: 37.5 }}
        x={450}
        y={500}
      />
    </Container>
  )
}
